import { FC } from 'react';
import { Button } from './styles';
import { Image } from './styles';

export interface IconButtonProps {
	iconSrc: string;
	isPrimary?: boolean;
	styles?: IconButtonStyles;
	role?: string;
	hide?: boolean;
	disableTouch?: boolean;
	onClick?: () => void;
	id?: string;
  disabled?: boolean
}

export interface IconButtonStyles {
	iconHeight?: string;
	paddingButton?: string;
	background?: string;
	width?: string;
	height?: string;
  margin?: string;
  [key: string]: any;
}

export const IconButton: FC<IconButtonProps> = ({
	iconSrc,
	isPrimary = false,
	styles,
	onClick,
	role = 'icon-button',
	hide = false,
	disableTouch = false,
	id,
  disabled
}) => {
	return (
		<Button
			role={role}
			$primary={isPrimary}
			$padding={styles?.paddingButton}
			$background={styles?.background}
			$width={styles?.width}
			$height={styles?.height}
			$margin={styles?.margin}
			$hide={hide}
			onClick={!window.matchMedia("(pointer: coarse)").matches || disableTouch ? onClick : undefined}
			onTouchStart={disableTouch ? undefined : onClick}
			id={id}
      disabled={disabled}
		>
			<Image role="image" src={iconSrc} height={styles?.iconHeight} />
		</Button>
	);
};
